import { useDisclosure } from '@mantine/hooks'
import { isEmpty, isString } from 'lodash'
import React, { memo, useEffect, useState } from 'react'
import { useQueryClient } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import ColetaClickstream from '../../../../components/clickstreamAnalise/clickstreamColeta.js'
import SpinerVeye from '../../../../components/spinnerVeye/spinnerVeye.js'
import { api_gateway } from '../../../../conexoes/api'
import {
  desabilitarAcoes,
  desabilitarAcoesCliente,
  exportarLinhas,
  exportarLinhasDesbloqueioCiclo,
  exportarOperadora,
  filtrosArrayBarra,
  limpadorFiltros,
  limpouBusca,
  modoSelecaoSimcard,
  mudarBuscaArquivo,
  mudarFiltros,
  mudarPermissaoElementoAcao,
  realizouBusca,
  realizouFiltro,
  revelarBarraFiltragem,
  RevelarBuscarEFiltro,
  revelarDispositivosAlterarCicloDeVida,
  revelarDispositivosAlterarPlano,
  revelarDispositivosAlterarServicos,
  revelarMostrarEmDispositivosSolicitacaoReset,
  separadorLinhaBusca
} from '../../../../redux/actions/index'
import { DispositivosService } from '../../../../services/http/dispositivos.service.js'
import { PortadorasService } from '../../../../services/http/portadoras.service.js'
import { useGlobal } from '../../../../stores/useGlobal.js'
import decryptJWT from '../../../../utils/decryptJWT'
import {
  getListaIccidsNaoEncontrados,
  getListaLinhasNaoEncontradas,
  montarXlsLinhasNaoEncontradas
} from '../../../../utils/exportarArquivo'
import { validadorPermissaoElemento } from '../../../../utils/verificadorPermissaoElemento'
import {
  AtencaoBaixarArquivoLinhasNaoEncontradas,
  BotaoInvisivelExportarLinhasNaoEncontradas,
  clickBotaoInvisivelExportarLinhasNaoEncontradas
} from '../../../buscaArquivo'
import AtivacaoLinhasAWS from '../../../componentesModais/importarLinhasAWS/ativacaoLinhasAWS'
import VerificacaoWhatsapp from '../../../componentesModais/importarVerificacaoWhatsapp/verificacaoWhatsapp'
import { RenderMensagemSucesso } from '../../../componentesModais/mensagens/mensagemAcao.js'
import AlterarCicloDeVida from '../../../painelFaturas/fatDispositivos/acoes/alterarCicloDeVida'
import AlterarPlano from '../../../painelFaturas/fatDispositivos/acoes/alterarPlano'
import AlterarServico from '../../../painelFaturas/fatDispositivos/acoes/alterarServico'
import AtribuirLinhas from '../../../painelFaturas/fatDispositivos/acoes/atribuirLinhas'
import NovoPedidoSimcard from '../../../painelPedidos/pedidosSimcard/novoPedido/novoPedido'
import PersonalizarColunas from '../../../personalizarColunas/personalizarColunas'
import {
  clickDesselecionarCheckboxVerde,
  desselecionarTodosCheckboxes
} from '../../../tabelaSelecao/checkboxSelecao'
import Table from '../../../Table/index.jsx'
import DestravarImei from '../../destravarImei'
import AdicionarPacoteExtra from '../../dspAdicionarPacoteExtra/adicionarPacoteExtra'
import AlterarPlanoValor from '../../dspAlterarPlanoValor/alterarPlanoValor'
import BloquearUso from '../../dspBloqueioDesbloqueio/bloquearUso'
import DesbloquearUso from '../../dspBloqueioDesbloqueio/desbloquearUso'
import DesbloqueioCiclo from '../../dspBloqueioDesbloqueio/desbloqueioCiclo'
import DesbloqueioPermanente from '../../dspBloqueioDesbloqueio/desbloqueioPermanente.js'
import BloquearTemporariamento from '../../dspBloqueioTemporario/bloquearTemporariamente'
import RemoverBloqueioTemporario from '../../dspBloqueioTemporario/removerBloqueioTemporario'
import CancelamentoConta from '../../dspCancelamentoConta/cancelamentoConta'
import Cancelamento from '../../dspCancelamentoReposicao/cancelamento'
import CancelamentoReposicao from '../../dspCancelamentoReposicao/cancelamentoReposicao'
import Realocacao from '../../dspCancelamentoReposicao/realocacao'
import AtivarDemonstracao from '../../dspDemonstracao/ativarDemonstracao'
import DesativarDemonstracao from '../../dspDemonstracao/desativarDemonstracao'
import DetalhamentoLinha from '../../dspDetalhamentoLinha/detalhamentoLinha'
import FalhaNaOperadora from '../../dspFalhaOperadora/falhaOperadora'
import AlterarGrupo from '../../dspGrupo/alterarGrupo'
import ConfigurarGrupo from '../../dspGrupo/configurarGrupo'
import ImportarDescricao from '../../dspImportarDescricao/ImportarDescricao'
import Mapa from '../../dspMapa/mapa'
import RelatorioConsumo from '../../dspRelatorioConsumo/RelatorioConsumo'
import RelatorioDisponibilidade from '../../dspRelatorioDisponibilidade/RelatorioDisponibilidade'
import RenegociarContrato from '../../dspRenegociarContrato/renegociarContrato.js'
import Reset from '../../dspReset/reset'
import BloquearSms from '../../dspSms/smsBloquear'
import EnviarSms from '../../dspSms/smsEnviar'
import LiberarSms from '../../dspSms/smsLiberar'
import SuporteTecnico from '../../dspSuporteTecnico/suporteTecnico'
import AtivarLinha from '../../dspSuspenderReativar/ativarLinha'
import ReativarLinha from '../../dspSuspenderReativar/reativarLinhas'
import SuspenderLinha from '../../dspSuspenderReativar/suspenderLinhas'
import TesteConexao from '../../dspTesteConexao/testeConexaoVivo.jsx'
import TrocaDeTitularidade from '../../dspTrocaDeTitularidade/trocaDeTitularidade'
import IotTelecom from '../../iotTelecom/iotTelecom'
import AlertaParqueTodo from '../Portadoras/Alertas/alertaParqueTodo.jsx'
import AlertaSimcardRemovido from '../Portadoras/Alertas/alertaSimcardRemovido.jsx'

import '../../../../css/painelDispositivos/dspSimcard/dspAcoes.css'

let contador = 0
let controladorPagina = 1
let paginaAntiga = 0
let totalPaginas = 0
let totalItens = 50
let valorLimite = 50
let totalExistente = 0
let itensVar = []
let operadorasSelecionadas = []
let ordem = {}
let alternadorSelecao = false

let chaveArquivoLinhasNaoEncontradas = false

//! Variável para gerenciar a redefinição dos filtros de dispositivos em portadoras
let auxAcaoMostrarEmPortadora = false

function RenderModalAcao({
  Acao,
  renderizar,
  setRenderizar,
  simcardsSelecionados,
  ...props
}) {
  let newProps = {
    renderizar,
    setRenderizar,
    simcardsSelecionados,
    closeModal: false,
    ...props
  }

  if (props.itensSelecionados) delete newProps.simcardsSelecionados

  return (
    <div className="componente-modal-overlay">
      <div className="componente-modal">
        <Acao {...newProps} />
      </div>
    </div>
  )
}

function TabelaDispositivos(props) {
  const { getDevicesPortadora } = PortadorasService
  const { getStatusContrato } = DispositivosService
  const { mostrarAcao, setMostrarAcao, setFiltros, setRevelarBarraFiltro } =
    useGlobal()
  const [cdSimcardsSelecionados, setCdSimcardsSelecionados] = useState([])
  const [simcardsSelecionados, setSimcardsSelecionados] = useState([])
  const [spinAtivo, setSpinAtivo] = useState(true)
  const [separador, setSeparador] = useState('espaco')
  const [itens, setItens] = useState([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(false)
  const [hasPermissionToViewCarriers, setHasPermissionToViewCarriers] =
    useState(false)
  const [permissaoDescricao, setPermissaoDescricao] = useState()
  const [
    dadosParaDownloadLinhasNaoEncontradas,
    setDadosParaDownloadLinhasNaoEncontradas
  ] = useState([['Linha', 'ICCID']])
  const [
    renderDadosParaDownloadLinhasNaoEncontradas,
    setRenderDadosParaDownloadLinhasNaoEncontradas
  ] = useState(false)
  const [revelarMensagemInformacao, setRevelarMensagemInformacao] =
    useState(false)
  const [revelarContador, setRevelarContador] = useState(false)
  const [showCaption, setShowCaption] = useState(false)
  const [limpandoSelecao, setLimpandoSelecao] = useState(false)

  const [mensagemSucesso, setMensagemSucesso] = useState(false)
  const [parqueTodo, setParqueTodo] = useState(false)
  const [idsPortadoras, setIdsPortadoras] = useState([])
  const [verificarWhatsapp, setVerificarWhatsapp] = useState(false)

  const [
    openedAlertaParqueTodo,
    { open: openAlertaParqueTodo, close: closeAlertaParqueTodo }
  ] = useDisclosure(false)
  const [
    openedAlertaSimcardRemovido,
    { open: openAlertaSimcardRemovido, close: closeAlertaSimcardRemovido }
  ] = useDisclosure(false)

  const revelarDestravarImei = mostrarAcao === 'revelarDestravarImei'

  const history = useHistory()

  const {
    modoSelecaoSimcard: reduxModoSelecaoSimcard,
    revelarAdicionarPacoteExtra,
    revelarReset,
    revelarTesteConexao,
    revelarFalhaNaOperadora,
    revelarSuporteTecnico,
    revelarCancelamento,
    revelarRealocacao,
    revelarAtivarLinha,
    revelarReativarLinha,
    revelarDesbloquearUso,
    revelarDesbloqueioCiclo,
    revelarDesbloqueioPermanente,
    revelarRemoverBloqueioTemporario,
    revelarSuspenderLinha,
    revelarBloquearUso,
    revelarBloquearTemporariamento,
    revelarAlterarPlanoValor,
    revelarAtribuirLinhas,
    revelarDesatribuirLinhas,
    revelarTrocaDeTitularidade,
    revelarAtivarDemonstracao,
    revelarDesativarDemonstracao,
    revelarCancelamentoDeConta,
    revelarIotTelecom,
    revelarAtivarLinhasAWS,
    revelarLiberarSms,
    revelarRenegociarContrato,
    revelarBloquearSms,
    revelarEnviarSms,
    revelarAlterarGrupo,
    revelarConfigurarGrupo,
    revelarExibirColunas,
    revelarImportarDescricao,
    revelarRelatorioConsumo,
    revelarCancelamentoReposicao,
    realizouFiltro: realizouFiltragem,
    exportarLinhas: revelarexportarLinhas,
    exportarOperadora: revelarexportarOperadora,
    revelarMapa,
    revelarRelatorioDisponibilidade,
    expandirNavegacao: estadoExpansaoMenu,
    conteudoBusca,
    limpouBusca: limpouBuscaGeral,
    realizouBusca: realizouBuscaGeral,
    ordenador,
    separadorLinha,
    exportarLinhasDesbloqueioCiclo: exportarLinhasDesbloqueioCicloState
  } = useSelector((state) => state.manejadorState)

  const { revelarNovoPedidoSimcard: revelarNovoPedido } = useSelector(
    (state) => state.pedidosState
  )

  const { filtros, limparFiltros } = useSelector((state) => state.filtrosState)

  const { buscaArquivo } = useSelector((state) => state.buscaArquivoState)

  const { permissaoElemento } = useSelector((state) => state.permissaoState)

  const {
    revelarDispositivosAlterarServicos: revelarDispositivosAlterarServicosVar,
    revelarDispositivosAlterarPlano: revelarDispositivosAlterarPlanoVar,
    revelarDispositivosAlterarCicloDeVida:
      revelarDispositivosAlterarCicloDeVidaVar,
    revelarDispositivosAlterarConta: revelarDispositivosAlterarContaVar
  } = useSelector((state) => state.faturasState)

  let revelarBarraFiltro = useSelector(
    (state) => state.filtrosState.revelarBarraFiltragem
  )

  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)
  const queryClient = useQueryClient()

  const despacho = useDispatch()
  let temFiltros = false

  useEffect(() => {
    if (
      (!filtros || filtros?.vazio) &&
      !conteudoBusca &&
      (!buscaArquivo || !Object.keys(buscaArquivo).length)
    ) {
      totalExistente = totalItens
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalItens, filtros, conteudoBusca, buscaArquivo])

  function GetIsSelecaoParcial() {
    const qtdSelecionados = simcardsSelecionados.length

    if (
      (qtdSelecionados && qtdSelecionados < totalExistente) ||
      (reduxModoSelecaoSimcard && totalItens < totalExistente)
    ) {
      return true
    }
    return false
  }
  const getFiltrosToBody = (filtros) => {
    if (filtros && !filtros?.vazio) {
      const keysFiltros = Object.keys(filtros)

      keysFiltros.map((key) => {
        if (filtros[key] === 'on') {
          delete filtros[key]
        }
      })
    }

    return filtros?.vazio === 'vazio' ? '' : `${JSON.stringify(filtros)}`
  }

  function onClickSelecaoParqueTodo(novoValor) {
    setParqueTodo(novoValor)
    if (novoValor === false) {
      desselecionarTodosCheckboxes('limparSelecao')

      setLimpandoSelecao(true)
      setShowCaption(false)
    }
    handleAlternarSelecao(novoValor)
  }

  const handleClickAlert = () => {
    closeAlertaSimcardRemovido(false)
  }

  const handleMostrarEmPortadoras = async () => {
    if ((parqueTodo && totalItens > 50) || simcardsSelecionados.length > 50) {
      openAlertaParqueTodo()
      setMostrarAcao(undefined)

      return
    }

    setSpinAtivo(true)

    const auxFiltros = {
      CD_SIMCARD: simcardsSelecionados.map((item) => item.CD_SIMCARD).join(',')
    }

    const filtro = isEmpty(auxFiltros) || parqueTodo ? filtros : auxFiltros

    await getDevicesPortadora(filtro, conteudoBusca, separador)
      .then((res) => {
        if (res.carrierIDs?.length) {
          if (res.showAlertNotification) openAlertaSimcardRemovido(true)
          setIdsPortadoras(res.carrierIDs)
        }
      })
      .catch((error) => {
        console.error(error)
      })
      .finally(() => setSpinAtivo(false))

    setMostrarAcao(undefined)
  }

  const openCarriersPage = () => {
    const limite = 2
    const totalPortadoras = idsPortadoras.length
    let label

    history.push('/veye/portadoras')

    despacho(
      mudarFiltros({
        ID_PORTADORA: idsPortadoras.join()
      })
    )
    setFiltros({
      ID_PORTADORA: idsPortadoras.join()
    })

    if (totalPortadoras <= limite) {
      label = `idPortadoraOperator: ${idsPortadoras.join(', ')}`
    } else {
      const portadorasExibidas = idsPortadoras.slice(0, limite)
      const restante = totalPortadoras - limite
      label = `idPortadoraOperator: ${portadorasExibidas.join(
        ', '
      )}... +${restante}`
    }

    despacho(filtrosArrayBarra([label]))
    setRevelarBarraFiltro(true)
  }

  useEffect(() => {
    if (!openedAlertaSimcardRemovido && idsPortadoras.length > 0) {
      openCarriersPage()
    }
  }, [idsPortadoras, openedAlertaSimcardRemovido])

  useEffect(() => {
    if (mostrarAcao === 'revelarMostrarEmPortadoras')
      handleMostrarEmPortadoras()
    else if (mostrarAcao === 'revelarVerificarWhatsapp') {
      setVerificarWhatsapp(true)
      setMostrarAcao(undefined)
    }
  }, [mostrarAcao])

  useEffect(() => {
    getPermissions()
    if (coletaUsabilidade) {
      ColetaClickstream(168) // 'dspSimcardTabelaSimcard'
      setColetaUsabilidade(false)
    }
    return () => {
      if (auxAcaoMostrarEmPortadora) return
      if (filtros.ID_PORTADORA || filtros.RADIO || filtros.CD_ESIM)
        removeFiltros()

      queryClient.removeQueries(['opcoes-filtros-dispositivos'], {
        exact: true
      })
    }
  }, [])

  const getPermissions = async () => {
    const clienteNivel = decryptJWT('clienteNivel')
    if (clienteNivel === 3) setHasPermissionToViewCarriers(false)
    else {
      const { dados } = (
        await api_gateway.post('/m1/servicos/dados/permissao', {
          id: decryptJWT('id')
        })
      ).data

      const cdMenus = dados.flatMap((item) =>
        Array.isArray(item)
          ? item.flatMap((subItem) => subItem.cdMenu)
          : item.cdMenu
      )
      const hasPermission = cdMenus.some((cd) => cd === 462) // (cdMenu: 462) Mostar em portadoras
      setHasPermissionToViewCarriers(hasPermission)
    }
  }

  const removeFiltros = () => {
    setFiltros({ vazio: 'vazio' })
    despacho(mudarFiltros({ vazio: 'vazio' }))
    despacho(revelarBarraFiltragem(false))
    despacho(filtrosArrayBarra([]))
  }

  async function handleMontarXlsLinhasNaoEncontradas(dados) {
    const dadosMontar = await montarXlsLinhasNaoEncontradas(dados)

    if (dadosMontar) {
      dadosParaDownloadLinhasNaoEncontradas.push(...dadosMontar)
      setRenderDadosParaDownloadLinhasNaoEncontradas(true)
    }
  }

  function handleMensagemAtencao() {
    if (renderDadosParaDownloadLinhasNaoEncontradas) {
      clickBotaoInvisivelExportarLinhasNaoEncontradas()
      setRenderDadosParaDownloadLinhasNaoEncontradas(false)
      setDadosParaDownloadLinhasNaoEncontradas([['Linha', 'ICCID']])
    }
  }

  useEffect(() => {
    function checarFiltros() {
      if (props.filtros.vazio == 'vazio') {
        temFiltros = false
      } else {
        temFiltros = true
        despacho(revelarMostrarEmDispositivosSolicitacaoReset(false))
      }
    }
    checarFiltros()
  }, [filtros])

  useEffect(() => {
    despacho(modoSelecaoSimcard(false))
    alternadorSelecao = reduxModoSelecaoSimcard
    async function handlerVerificarPermissaoAcao() {
      despacho(
        mudarPermissaoElementoAcao(
          !(await validadorPermissaoElemento(
            permissaoElemento,
            'veye/dispositivos/acoes'
          ))
        )
      )
      setPermissaoDescricao(
        await validadorPermissaoElemento(
          permissaoElemento,
          'veye/dispositivos/detalhamento'
        )
      )
    }
    handlerVerificarPermissaoAcao()
  }, [permissaoElemento])

  useEffect(() => {
    if (limparFiltros) {
      despacho(revelarBarraFiltragem(false))
      if (!props.filtros.vazio) {
        despacho(mudarFiltros({ vazio: 'vazio' }))
        despacho(revelarBarraFiltragem(false))
        despacho(limpadorFiltros(false))
        despacho(filtrosArrayBarra([]))
      }
    }
  }, [])

  useEffect(() => {
    restaurarConfigsIniciaisPagina()
  }, [props.ordenador])

  useEffect(() => {
    async function pegarSeparador() {
      const separador = await api_gateway
        .get(
          '/m1/consultar/preferencias?cd_pav_usuario=' + decryptJWT('codigo')
        )
        .then(function (resposta) {
          return resposta.data.dados[0]
        })
        .catch(function (erro) {
          throw erro.stack
        })

      setSeparador(separador.busca_separador)
      despacho(separadorLinhaBusca(separador.busca_separador))
    }

    pegarSeparador()
  }, [])

  useEffect(() => {
    const controller = new AbortController()

    if (simcardsSelecionados.length === 0) {
      despacho(desabilitarAcoes(true))
    }

    const limparBuscaPorArquivo = () => despacho(mudarBuscaArquivo({}))

    const getParams = (body, separadorLinha) => {
      if (body.busca) {
        if (separadorLinha === `enter`) {
          body.busca = body.busca.replaceAll(`\\n`, ';')
          body.busca = body.busca.replaceAll(' ', ';')
        }
        if (separadorLinha === `espaco`) {
          body.busca = body.busca.replaceAll(' ', ';')
        }
        if (separadorLinha === `,`) {
          body.busca = body.busca.replaceAll(',', ';')
        }
        if (separadorLinha === `|`) {
          body.busca = body.busca.replaceAll('|', ';')
        }
      }
      const keys = Object.keys(body)
      let strParams = ''
      for (let idx = 0; idx < keys.length; idx++) {
        const key = keys[idx]
        if (idx > 0) strParams += '&'
        strParams += `${key}=${body[key]}`
      }
      return strParams
    }

    async function getSimcardsFiltrados() {
      const body2 = {
        campos: 'CALLERID,ICCID',
        busca: conteudoBusca,
        contar: false,
        filtro: getFiltrosToBody(filtros)
      }

      const params = getParams(
        {
          ...body2,
          buscaArquivo: buscaArquivo
            ? JSON.stringify(buscaArquivo)
            : buscaArquivo
        },
        separadorLinha
      )

      const res = await api_gateway.get(`/m1/filtrar/simcard?${params}`, {
        signal: controller.signal
      })

      if (res?.data?.dados) {
        res.data.devices = res.data.dados
        delete res.data.dados
      }
      return res
    }

    async function carregarTabela() {
      let desselecionarCheckboxAposRecarregarTabela = false

      async function getDadosDispositivos({ body, atualizaDados = true }) {
        setRevelarContador(false)

        const simcards_SV = await fazRequisicaoDispositivos({
          body,
          signal: controller.signal
        })
        if (!mudouPagina) await funcContador(simcards_SV)
        if (atualizaDados) inserirData(simcards_SV.data.devices)

        setRevelarContador(true)
        return simcards_SV
      }

      async function fazRequisicaoDispositivos({ body, signal }) {
        const urlFiltrarSimcard = '/api/v2/devices/simcard'
        let buscaArquivoStr = JSON.stringify(buscaArquivo)

        if (filtros?.ICCID && buscaArquivo?.chave) {
          buscaArquivoStr = '{}'
          limparBuscaPorArquivo()
        }

        body.buscaArquivo = buscaArquivoStr
        const fazRequisicaoPOST = async () =>
          api_gateway.post(urlFiltrarSimcard, body, { signal })

        const fazRequisicaoGET = async () => {
          let urlGet = urlFiltrarSimcard + '?' + getParams(body, separadorLinha)
          return api_gateway.get(urlGet, { signal })
        }

        const limiteGetEvitarErro414 = 250
        if (
          filtros?.ICCID?.length > limiteGetEvitarErro414 ||
          filtros?.LINHA?.length > limiteGetEvitarErro414
        ) {
          return fazRequisicaoPOST()
        } else {
          return fazRequisicaoGET()
        }
      }

      setSpinAtivo(true)
      if (limpouBuscaGeral) {
        despacho(limpouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      if (realizouBuscaGeral) {
        despacho(realizouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      if (realizouFiltragem) {
        despacho(realizouFiltro(false))
        restaurarConfigsIniciaisPagina()
      }

      if (temFiltros) {
        temFiltros = false
        restaurarConfigsIniciaisPagina()
      }

      valorLimite = 50

      setItens([])
      if (totalPaginas != 0) {
        contador = (paginaAtual - 1) * valorLimite
      } else if (!props.conteudoBusca) {
        if (filtros.PACOTE_EXTRA && filtros.PACOTE_EXTRA == 'on') {
          delete filtros.PACOTE_EXTRA
        }
        if (filtros.PLANO_TIPO && filtros.PLANO_TIPO == 'on') {
          delete filtros.PLANO_TIPO
        }
        if (filtros.SMS_ATIVADO && filtros.SMS_ATIVADO == 'on') {
          delete filtros.SMS_ATIVADO
        }
        if (filtros.TECNOLOGIA && filtros.TECNOLOGIA == 'on') {
          delete filtros.TECNOLOGIA
        }
        if (filtros.TIPO_SIMCARD && filtros.TIPO_SIMCARD == 'on') {
          delete filtros.TIPO_SIMCARD
        }
        if (filtros.TRAFEGO && filtros.TRAFEGO == 'on') {
          delete filtros.TRAFEGO
        }
        if (filtros.ULTIMA_CONEXAO && filtros.ULTIMA_CONEXAO == 'on') {
          delete filtros.ULTIMA_CONEXAO
        }
        despacho(RevelarBuscarEFiltro(false))
      }

      if (isString(filtros.STATUS_CONTRATO)) {
        const tipos = await getStatusContrato()

        let status = filtros.STATUS_CONTRATO

        if (status === 'PRE ATIVO') status = 'PRE-ATIVO'

        //* Remove acentos e pontuaçoes das string "DEMONSTRAÇÃO" = "DEMONSTRACAO"
        const normalize = (str) =>
          str.normalize('NFD').replace(/\p{Diacritic}/gu, '')

        const statusFiltro = normalize(status)

        const statusContrato = tipos.find(
          (tipo) => normalize(tipo.SITUACAO) === statusFiltro
        )

        if (statusContrato) {
          filtros.STATUS_CONTRATO = statusContrato.CD_SITUACAO
        }
      }

      async function funcContador(apiData) {
        totalItens = apiData.data.item_count

        let arrayItens = []
        totalPaginas = Math.ceil(totalItens / valorLimite)

        for (var i = 0; i < totalItens; i++) {
          arrayItens.push(i)
        }

        itensVar = arrayItens
        despacho(RevelarBuscarEFiltro(true))

        desselecionarCheckboxAposRecarregarTabela = true
      }

      const apenasBusca =
        props.conteudoBusca && props.filtros.vazio && !props.buscaArquivo?.chave

      let trazerCount = true

      const mudouPagina = paginaAntiga !== 0 && paginaAntiga !== paginaAtual

      if (mudouPagina) {
        trazerCount = false
      }

      if (apenasBusca) {
        if (controladorPagina <= paginaAtual) {
          const body = {
            limit: valorLimite,
            offset: contador,
            busca: conteudoBusca,
            ordenador: ordenador,
            contar: trazerCount
          }
          await getDadosDispositivos({ body })
        }
      } else if (props.buscaArquivo?.chave) {
        if (totalItens >= 1) {
          if (controladorPagina <= paginaAtual) {
            const body = {
              limit: valorLimite,
              offset: contador,
              busca: conteudoBusca,
              ordenador: ordenador,
              contar: trazerCount,
              filtro: getFiltrosToBody(filtros)
            }
            const simcards = await getDadosDispositivos({
              body,
              atualizaDados: false
            })

            const aindaNaoGerouArquivoLinhasNaoEncontradas = (chave) =>
              chaveArquivoLinhasNaoEncontradas !== chave

            if (
              simcards?.data?.devices?.length > 0 &&
              simcards?.status == 200 &&
              aindaNaoGerouArquivoLinhasNaoEncontradas(buscaArquivo.chave)
            ) {
              chaveArquivoLinhasNaoEncontradas = buscaArquivo.chave

              const dados = {
                chave: buscaArquivo.chave,
                usuario: decryptJWT('codigo')
              }

              const getDadosArquivo = async () => {
                return api_gateway.post(
                  '/m1/filtrar/dsp_iccid_ou_linhas_nao_encontrados',
                  dados
                )
              }

              const [simcards2Data, dataLinhasNaoEncontradas] =
                await Promise.allSettled([
                  getSimcardsFiltrados(),
                  getDadosArquivo()
                ]).then((responses) => {
                  return responses.map((promiseRes) => {
                    const { status, data } = promiseRes?.value || {}
                    if (promiseRes?.status === 'fulfilled' && status === 200) {
                      return data
                    }
                  })
                })
              const simcardsArquivo = simcards2Data.devices
              if (simcardsArquivo !== undefined) {
                const simsEncontrados = { dados: simcardsArquivo, status: 200 }

                const listaIccids = await getListaIccidsNaoEncontrados({
                  dataLinhasNaoEncontradas,
                  simcards: simsEncontrados,
                  dspSimcard: true
                })
                handleMontarXlsLinhasNaoEncontradas(listaIccids)

                const listaLinhas = await getListaLinhasNaoEncontradas({
                  dataLinhasNaoEncontradas,
                  simcards: simsEncontrados,
                  dspSimcard: true
                })
                handleMontarXlsLinhasNaoEncontradas(listaLinhas)
                despacho(limpadorFiltros(true))
              }
            }
            inserirData(simcards.data.devices)
          }
        }
      } else if (totalItens >= 1 && controladorPagina <= paginaAtual) {
        const body = {
          limit: valorLimite,
          offset: contador,
          busca: conteudoBusca,
          ordenador: ordenador,
          filtro: getFiltrosToBody(filtros),
          contar: trazerCount
        }
        await getDadosDispositivos({ body })
      }

      setSpinAtivo(false)
      if (
        desselecionarCheckboxAposRecarregarTabela &&
        !simcardsSelecionados?.length
      ) {
        if (alternadorSelecao) {
          onClickSelecaoParqueTodo(false)
        } else {
          desselecionarTodosCheckboxes('alterouDadosTabela')
        }
      }
    }
    carregarTabela()

    return () => {
      controller.abort()
    }
  }, [
    paginaAtual,
    props.conteudoBusca,
    renderizar,
    props.filtros,
    props.buscaArquivo,
    ordem,
    props.ordenador
  ])

  function inserirData(data) {
    for (let i = 0; i < totalItens; i++) {
      if (contador === i) {
        let k = i
        for (let j = 0; j < data.length; j++) {
          itensVar[k] = data[j]
          k++
        }
      }
      if (i == totalItens - 1) {
        setItens(JSON.parse(JSON.stringify(itensVar)))
      }
    }
    setSpinAtivo(false)

    if (limpandoSelecao) {
      clickDesselecionarCheckboxVerde(false)
    }
  }

  function mapearDadoDetalhamentoLinha(dados) {
    let detalhamento = ''
    itens.map((item_simcard) => {
      if (item_simcard.CD_SIMCARD === dados.CD_SIMCARD) {
        detalhamento = item_simcard
      }
    })
    return [detalhamento]
  }

  useEffect(() => {
    if (exportarLinhasDesbloqueioCicloState !== false) {
      setSpinAtivo(true)
      const data = {
        codigo_cliente: decryptJWT('codigoCliente'),
        codigo_usuario: decryptJWT('codigo'),
        descricao: 'Relatório de Solicitações de Desbloqueio no Ciclo',
        tipo_relatorio: 33,
        tipo_arquivo: exportarLinhasDesbloqueioCicloState
      }

      api_gateway
        .post('/m1/cadastrar/relatorios', data)
        .then(() => {
          setSpinAtivo(false)
        })
        .catch(() => {
          setSpinAtivo(false)
        })
      despacho(exportarLinhasDesbloqueioCiclo(false))
    }
  }, [exportarLinhasDesbloqueioCicloState])

  async function handleExportarLinhas() {
    setSpinAtivo(true)
    if (reduxModoSelecaoSimcard && revelarexportarOperadora == false) {
      const dados = {
        descricao: 'Relatório de SIM cards buscando pelo parque inteiro',
        tipo_arquivo: revelarexportarLinhas,
        tipo_relatorio: 6,
        filtros: filtros,
        buscaArquivo,
        buscar: conteudoBusca,
        separador: separadorLinha,
        contar: false
      }
      api_gateway.post('/m1/cadastrar/relatorios', dados)
      handleMensagemInformacao(true)
      despacho(exportarLinhas(false))
      despacho(exportarOperadora(false))
    } else if (reduxModoSelecaoSimcard && revelarexportarOperadora == true) {
      const dados = {
        descricao: 'Relatório de SIM cards buscando pelo parque inteiro',
        tipo_arquivo: revelarexportarLinhas,
        tipo_relatorio: 23,
        filtros: filtros,
        buscaArquivo,
        buscar: conteudoBusca,
        separador: separadorLinha,
        contar: false
      }
      api_gateway.post('/m1/cadastrar/relatorios', dados)
      handleMensagemInformacao(true)
      despacho(exportarLinhas(false))
      despacho(exportarOperadora(false))
    } else {
      let auxArrayCdSimcard = []
      simcardsSelecionados.map((simcard) => {
        if (
          simcard.CD_SIMCARD !== undefined &&
          simcard.CD_SIMCARD !== null &&
          simcard.CD_SIMCARD !== ''
        ) {
          auxArrayCdSimcard.push(simcard.CD_SIMCARD)
        } else {
          auxArrayCdSimcard.push(simcard.FAT_CD_SIMCARD)
        }
      })
      const dados = {
        descricao: 'Relatório de SIM cards buscando por linhas específicas',
        tipo_arquivo: revelarexportarLinhas,
        tipo_relatorio: 6,
        tipo_relatorioOperadora: 23,
        arrayCdSimcard: auxArrayCdSimcard,
        filtros: filtros,
        buscaArquivo,
        buscar: conteudoBusca,
        separador: separadorLinha,
        contar: false,
        operadoraAtual: revelarexportarOperadora
      }
      await api_gateway.post('/m1/cadastrar/relatorios', dados)
      handleMensagemInformacao(true)
      despacho(exportarLinhas(false))
      despacho(exportarOperadora(false))
    }
    setSpinAtivo(false)
  }

  useEffect(() => {
    if (revelarexportarLinhas) {
      handleExportarLinhas()
    }
  }, [revelarexportarLinhas])

  function handleMensagemInformacao(confirmacao) {
    if (revelarMensagemInformacao === false) {
      setRevelarMensagemInformacao(true)
    } else {
      setRevelarMensagemInformacao(false)
      if (confirmacao === true) {
        setRenderizar(!renderizar)
      }
    }
  }

  function handleSelecionarTodosSimcards(rows) {
    ColetaClickstream(179) // 'dspSimcardTabelaSimcardHandleSelecionarTodosSimcards'
    rows.map((item, i) => {
      simcardsSelecionados.push(rows[i])
    })
    despacho(desabilitarAcoes(false))
    despacho(desabilitarAcoesCliente(true))
  }

  function handleDesselecionarTodosSimcards(rows) {
    ColetaClickstream(180) // 'dspSimcardTabelaSimcardHandleDesselecionarTodosSimcards'
    rows.map((item, i) => {
      simcardsSelecionados.map((simcards, x) => {
        if (rows[i].CD_SIMCARD === simcardsSelecionados[x].CD_SIMCARD) {
          simcardsSelecionados.splice(x, 1)
        }
      })
    })
    if (simcardsSelecionados.length === 0) {
      setSimcardsSelecionados([])
      setCdSimcardsSelecionados([])
      despacho(desabilitarAcoes(true))
    }
  }

  function handleSelecionarSimcard(simcard) {
    ColetaClickstream(181) // 'dspSimcardTabelaSimcardHandleSelecionarSimcard'
    for (let i = 0; i < itens.length; i++) {
      if (itens[i].CD_SIMCARD === simcard) {
        simcardsSelecionados.push(itens[i])
        operadorasSelecionadas.push(itens[i].DS_PEDIDO_OPERADORA)
        break
      }
    }
    despacho(desabilitarAcoes(false))
    despacho(desabilitarAcoesCliente(true))
  }

  function handleDesselecionarSimcard(simcard) {
    ColetaClickstream(182) // 'dspSimcardTabelaSimcardHandleDesselecionarSimcard'
    for (let i = 0; i < simcardsSelecionados.length; i++) {
      if (simcardsSelecionados[i].CD_SIMCARD === simcard) {
        simcardsSelecionados.splice(i, 1)
        operadorasSelecionadas.splice(i, 1)
        break
      }
    }
    if (simcardsSelecionados.length == 0) {
      despacho(desabilitarAcoes(true))
    }
  }

  function trocarPagina(novaPagina) {
    paginaAntiga = paginaAtual
    setPaginaAtual(novaPagina)
  }

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    paginaAntiga = 0
    controladorPagina = 1
    totalItens = 50
    valorLimite = 50
    setSimcardsSelecionados([])
    setCdSimcardsSelecionados([])
    despacho(desabilitarAcoes(true))
    despacho(desabilitarAcoesCliente(true))
    setPaginaAtual(1)
  }

  function handleAlternarSelecao(valor) {
    alternadorSelecao = valor
    despacho(modoSelecaoSimcard(valor))
    if (valor) {
      despacho(desabilitarAcoes(false))
      despacho(desabilitarAcoesCliente(true))
    } else {
      despacho(desabilitarAcoes(true))
      despacho(desabilitarAcoesCliente(false))
    }
    setSimcardsSelecionados([])
    setCdSimcardsSelecionados([])
  }

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens
  const getTotalItensNaPagina = () => getLimiteNaPagina()

  function handleRespostaSolicitacao({ response, error }) {
    let arrMsgSucesso = {
      arrTexto: ['Sucesso', 'Solicitação enviada'],
      btnTexto: 'Continuar'
    }

    if (response) {
      fecharModalAcao()

      const { linhasInvalidas } = response?.data || {}
      const qtdInvalidas = linhasInvalidas?.length
      if (qtdInvalidas) {
        arrMsgSucesso = {
          arrTexto: [
            'Solicitação enviada',
            `Foram encontradas ${qtdInvalidas} linhas inválidas na sua solicitação. 
                             Todas as demais linhas foram incluídas.`,
            'Clique em baixar para verificar as linhas inválidas.'
          ],
          btnTexto: 'Fechar',
          linhasInvalidas
        }
      }

      handleMensagemSucesso(false, arrMsgSucesso)
    } else if (error) {
      const resp = error?.response
      const respDados = resp?.data
      const mensagemErro = respDados?.info

      if (mensagemErro && [400, 401].includes(resp?.status)) {
        return { atencao: mensagemErro }
      } else {
        console.error(error)
        return { erro: true }
      }
    }
  }

  function fecharModalAcao() {
    if (revelarDispositivosAlterarCicloDeVidaVar) {
      despacho(revelarDispositivosAlterarCicloDeVida(false))
    } else if (revelarDispositivosAlterarPlanoVar) {
      despacho(revelarDispositivosAlterarPlano(false))
    } else if (revelarDispositivosAlterarServicosVar) {
      despacho(revelarDispositivosAlterarServicos(false))
    }
  }

  function handleMensagemSucesso(confirmacao, arrMsgSucesso) {
    if (mensagemSucesso === false) {
      setMensagemSucesso(arrMsgSucesso)
    } else {
      setMensagemSucesso(false)
    }
    if (confirmacao) {
      setRenderizar(!renderizar)
    }
  }

  const modaisConfig = [
    {
      condicao: revelarDestravarImei,
      acao: DestravarImei,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarAdicionarPacoteExtra,
      acao: AdicionarPacoteExtra,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarReset,
      acao: Reset,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarTesteConexao,
      acao: TesteConexao,
      props: {
        totalItensPreSelecao: totalItens,
        itensSelecionados: simcardsSelecionados
      }
    },
    {
      condicao: revelarFalhaNaOperadora,
      acao: FalhaNaOperadora,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarSuporteTecnico,
      acao: SuporteTecnico,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarCancelamento,
      acao: Cancelamento,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarRealocacao,
      acao: Realocacao,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarNovoPedido,
      acao: NovoPedidoSimcard,
      props: { reposicao: 1 }
    },
    {
      condicao: revelarAtivarLinha,
      acao: AtivarLinha,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarReativarLinha,
      acao: ReativarLinha,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarDesbloquearUso,
      acao: DesbloquearUso,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarDesbloqueioCiclo,
      acao: DesbloqueioCiclo,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarDesbloqueioPermanente,
      acao: DesbloqueioPermanente,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarRemoverBloqueioTemporario,
      acao: RemoverBloqueioTemporario,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarSuspenderLinha,
      acao: SuspenderLinha,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarBloquearUso,
      acao: BloquearUso,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarBloquearTemporariamento,
      acao: BloquearTemporariamento,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarAlterarPlanoValor,
      acao: AlterarPlanoValor,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarAtribuirLinhas,
      acao: AtribuirLinhas,
      props: {
        itensSelecionados: simcardsSelecionados,
        acaoModal: 'Atribuir'
      }
    },
    {
      condicao: revelarDesatribuirLinhas,
      acao: AtribuirLinhas,
      props: {
        itensSelecionados: simcardsSelecionados,
        acaoModal: 'Desatribuir'
      }
    },
    {
      condicao: revelarTrocaDeTitularidade,
      acao: TrocaDeTitularidade,
      props: {
        itensSelecionados: simcardsSelecionados,
        isSelecaoParcial: GetIsSelecaoParcial()
      }
    },
    {
      condicao: revelarCancelamentoDeConta,
      acao: CancelamentoConta,
      props: { itensSelecionados: simcardsSelecionados }
    },
    { condicao: revelarIotTelecom, acao: IotTelecom, props: {} },
    {
      condicao: revelarAtivarLinhasAWS,
      acao: AtivacaoLinhasAWS,
      props: { origem: 'tabelaSimcard' }
    },
    {
      condicao: verificarWhatsapp,
      acao: VerificacaoWhatsapp,
      props: {
        origem: 'tabelaSimcard',
        closeModal: () => setVerificarWhatsapp(false)
      }
    },
    {
      condicao: revelarAtivarDemonstracao,
      acao: AtivarDemonstracao,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarDesativarDemonstracao,
      acao: DesativarDemonstracao,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarLiberarSms,
      acao: LiberarSms,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarBloquearSms,
      acao: BloquearSms,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarCancelamentoReposicao,
      acao: CancelamentoReposicao,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarEnviarSms,
      acao: EnviarSms,
      props: { itensSelecionados: simcardsSelecionados }
    },
    {
      condicao: revelarMapa,
      acao: Mapa,
      className: 'componente-modal-mapa',
      props: {}
    },
    {
      condicao: revelarAlterarGrupo,
      acao: AlterarGrupo,
      props: { itensSelecionados: simcardsSelecionados }
    },
    { condicao: revelarConfigurarGrupo, acao: ConfigurarGrupo, props: {} },
    { condicao: revelarImportarDescricao, acao: ImportarDescricao, props: {} },
    {
      condicao: revelarRelatorioConsumo,
      acao: RelatorioConsumo,
      props: { filtros, buscaArquivo, conteudoBusca, separadorLinha }
    },
    {
      condicao: revelarRelatorioDisponibilidade,
      acao: RelatorioDisponibilidade,
      props: { filtros, buscaArquivo, conteudoBusca, separadorLinha }
    },
    {
      condicao: revelarExibirColunas,
      acao: PersonalizarColunas,
      props: { render: props.render, setRender: props.setRender }
    },
    {
      condicao: revelarDispositivosAlterarServicosVar,
      acao: AlterarServico,
      props: { operadorasSelecionadas, handleRespostaSolicitacao }
    },
    {
      condicao: revelarDispositivosAlterarPlanoVar,
      acao: AlterarPlano,
      props: { operadorasSelecionadas, handleRespostaSolicitacao }
    },
    {
      condicao: revelarDispositivosAlterarContaVar,
      acao: AlterarCicloDeVida,
      props: { operadorasSelecionadas, handleRespostaSolicitacao }
    },
    {
      condicao: revelarDispositivosAlterarCicloDeVidaVar,
      acao: AlterarCicloDeVida,
      props: { operadorasSelecionadas, handleRespostaSolicitacao }
    }
  ]

  const handleOnSelect = (row, isSelect) => {
    if (limpandoSelecao) setLimpandoSelecao(false)

    if (isSelect) {
      setCdSimcardsSelecionados((prev) => [...prev, row.CD_SIMCARD])
      handleSelecionarSimcard(row.CD_SIMCARD)
    } else {
      setCdSimcardsSelecionados((prev) =>
        prev.filter((id) => id !== row.CD_SIMCARD)
      )
      handleDesselecionarSimcard(row.CD_SIMCARD)
      if (showCaption) setShowCaption(false)
    }
  }

  const handleOnSelectAll = (isSelect, rows) => {
    if (limpandoSelecao) setLimpandoSelecao(false)

    if (isSelect && !limpandoSelecao) {
      const allIds = rows.map((r) => r.CD_SIMCARD)
      setCdSimcardsSelecionados((prev) => [...prev, ...allIds])
      handleSelecionarTodosSimcards(rows)
      setShowCaption(true)
    } else {
      setCdSimcardsSelecionados((prev) =>
        prev.filter((id) => !rows.some((r) => r.CD_SIMCARD === id))
      )
      handleDesselecionarTodosSimcards(rows)
      desselecionarTodosCheckboxes('limparSelecao')
      if (showCaption) setShowCaption(false)
    }
  }

  const renderDetalhamentoLinha = (row) => {
    return (
      <div
        className={
          estadoExpansaoMenu === true
            ? 'expand-row-tabela-dispositivos-1'
            : 'expand-row-tabela-dispositivos-2'
        }
      >
        <DetalhamentoLinha
          renderConsultaColunas={props.render}
          setRenderConsultaColunas={props.setRender}
          row={mapearDadoDetalhamentoLinha(row)}
          cdSimcard={row.CD_SIMCARD}
          gsm={row.FULLCALLERID}
          previsaoConsumo={row.PREVISAO}
          plano={row.PLANO + row.EXCEDENTE}
          renderizar={renderizar}
          setRenderizar={setRenderizar}
          permissions={{ portadoras: hasPermissionToViewCarriers }}
        />
      </div>
    )
  }

  return (
    <>
      <div className="container-tela">
        <Table
          keyField="CD_SIMCARD"
          enableDrag
          clickToSelect
          itens={itens}
          colunas={props.colunas}
          revelarBarraFiltro={revelarBarraFiltro}
          permissaoDetalhamentoLinha={permissaoDescricao}
          detalhamentLinha={renderDetalhamentoLinha}
          spinAtivo={spinAtivo}
          showCaption={showCaption}
          setShowCaption={setShowCaption}
          revelarContador={revelarContador}
          getTotalItensNaPagina={getTotalItensNaPagina}
          getLimiteNaPagina={getTotalItensNaPagina}
          pagination={{
            paginaAtual,
            valorLimite,
            totalPaginas,
            totalItens,
            contador,
            trocarPagina,
            onDragEnd: props.onDragEnd
          }}
          selection={{
            itensSelecionados: cdSimcardsSelecionados,
            modeSelection: 'checkbox',
            handleOnSelect,
            handleOnSelectAll,
            onClickSelecaoParqueTodo
          }}
        />
        {spinAtivo && (
          <div className="componente-spinner-overlay">
            <div className="componente-spinner-container">
              <SpinerVeye />
            </div>
          </div>
        )}
        <BotaoInvisivelExportarLinhasNaoEncontradas
          {...{ dadosParaDownloadLinhasNaoEncontradas }}
        />
        {mensagemSucesso && (
          <RenderMensagemSucesso
            {...{ mensagemSucesso, handleMensagemSucesso }}
          />
        )}
        {renderDadosParaDownloadLinhasNaoEncontradas && (
          <AtencaoBaixarArquivoLinhasNaoEncontradas
            {...{
              handleMensagemAtencao,
              dadosParaDownloadLinhasNaoEncontradas
            }}
          />
        )}
        {modaisConfig.map(({ condicao, acao, props, className }, index) =>
          condicao ? (
            <RenderModalAcao
              renderizar={renderizar}
              setRenderizar={setRenderizar}
              simcardsSelecionados={simcardsSelecionados}
              key={index}
              className={className || 'componente-modal'}
              Acao={acao}
              {...props}
            />
          ) : null
        )}
        {revelarRenegociarContrato === true && (
          <div className="componente-modal-overlay">
            <div className="componente-modal">
              <RenegociarContrato
                renderizar={renderizar}
                setRenderizar={setRenderizar}
                itensSelecionados={simcardsSelecionados}
              />
            </div>
          </div>
        )}
        {revelarDispositivosAlterarContaVar && (
          <RenderModalAcao
            className="componente-modal"
            Acao={AlterarCicloDeVida}
            {...{ operadorasSelecionadas, handleRespostaSolicitacao }}
          />
        )}
        {revelarDispositivosAlterarCicloDeVidaVar && (
          <RenderModalAcao
            className="componente-modal"
            Acao={AlterarCicloDeVida}
            {...{ operadorasSelecionadas, handleRespostaSolicitacao }}
          />
        )}
        {openedAlertaSimcardRemovido && (
          <AlertaSimcardRemovido
            opened={openedAlertaSimcardRemovido}
            onClick={() => handleClickAlert()}
            hasData={!!idsPortadoras.length}
          />
        )}
        {openedAlertaParqueTodo && (
          <AlertaParqueTodo
            opened={openedAlertaParqueTodo}
            onClick={() => closeAlertaParqueTodo()}
          />
        )}
      </div>
    </>
  )
}

export default memo(TabelaDispositivos)
